import React, { useEffect, useState } from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import { Menu, X } from 'lucide-react';
export const Navbar = () => {
  const [isScrolled, setIsScrolled] = useState(false);
  const [isMobileMenuOpen, setIsMobileMenuOpen] = useState(false);
  useEffect(() => {
    const handleScroll = () => {
      setIsScrolled(window.scrollY > 50);
    };
    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);
  const navLinks = [{
    name: 'About',
    href: '#mission'
  }, {
    name: 'Services',
    href: '#services'
  }, {
    name: 'Success',
    href: '#success'
  }, {
    name: 'Team',
    href: '#team'
  }, {
    name: 'Network',
    href: '#network'
  }];
  return <header className={`fixed top-0 left-0 right-0 z-50 transition-all duration-300 ${isScrolled ? 'bg-navy-900/90 backdrop-blur-md py-4 shadow-lg shadow-navy-900/50' : 'bg-transparent py-6'}`} data-id="element-142">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-143">
        <div className="flex justify-between items-center" data-id="element-144">
          {/* Logo */}
          <a href="#" className="flex items-center gap-3 group" data-id="element-145">
            <img src="https://cdn.magicpatterns.com/uploads/ryk41TLetQu6VxX6oqEWhT/FullLogo.png" alt="Universal Hockey Development" className={`transition-all duration-300 object-contain ${isScrolled ? 'h-10' : 'h-14'}`} data-id="element-146" />
            <div className="hidden sm:flex flex-col" data-id="element-147">
              <span className="text-white font-bold text-lg leading-none tracking-wide" data-id="element-148">
                UNIVERSAL HOCKEY
              </span>
              <span className="text-ice-500 text-xs font-semibold tracking-widest uppercase" data-id="element-149">
                Development
              </span>
            </div>
          </a>

          {/* Desktop Nav */}
          <nav className="hidden md:flex items-center gap-8" data-id="element-150">
            {navLinks.map(link => <a key={link.name} href={link.href} className="text-sm font-medium text-slate-300 hover:text-white transition-colors relative group" data-id="element-151">
                {link.name}
                <span className="absolute -bottom-1 left-0 w-0 h-0.5 bg-ice-500 transition-all duration-300 group-hover:w-full" data-id="element-152"></span>
              </a>)}
            <a href="#contact" className="px-5 py-2.5 bg-gold-500 hover:bg-gold-400 text-navy-900 text-sm font-bold rounded-sm transition-colors" data-id="element-153">
              Get in Touch
            </a>
          </nav>

          {/* Mobile Menu Toggle */}
          <button className="md:hidden text-white p-2" onClick={() => setIsMobileMenuOpen(!isMobileMenuOpen)} aria-label="Toggle menu" data-id="element-154">
            {isMobileMenuOpen ? <X size={24} data-id="element-155" /> : <Menu size={24} data-id="element-156" />}
          </button>
        </div>
      </div>

      {/* Mobile Nav */}
      <AnimatePresence data-id="element-157">
        {isMobileMenuOpen && <motion.div initial={{
        opacity: 0,
        height: 0
      }} animate={{
        opacity: 1,
        height: 'auto'
      }} exit={{
        opacity: 0,
        height: 0
      }} className="md:hidden bg-navy-800 border-t border-navy-700 overflow-hidden" data-id="element-158">
            <div className="px-4 py-6 flex flex-col gap-4" data-id="element-159">
              {navLinks.map(link => <a key={link.name} href={link.href} className="text-lg font-medium text-slate-300 hover:text-white transition-colors" onClick={() => setIsMobileMenuOpen(false)} data-id="element-160">
                  {link.name}
                </a>)}
              <a href="#contact" className="mt-4 px-5 py-3 bg-gold-500 text-navy-900 text-center font-bold rounded-sm" onClick={() => setIsMobileMenuOpen(false)} data-id="element-161">
                Get in Touch
              </a>
            </div>
          </motion.div>}
      </AnimatePresence>
    </header>;
};